import { Injectable, inject } from '@angular/core'
import { Router } from '@angular/router'
import { AuthenticationService } from './authentication.service'

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard {
  private authenticationService = inject(AuthenticationService);
  private router = inject(Router);


  canActivate() {
    if (this.authenticationService.isAuthenticated$.value) {
      return true
    } else {
      this.redirectToLoginPage()
      return false
    }
  }

  redirectToLoginPage() {
    this.router.navigate(['/login'])
  }
}
